import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as CommonActions from './common.actions';
import * as fromCommon from './common.reducer';
import * as CommonSelectors from './common.selectors';

@Injectable()
export class CommonFacade {
  editMode$ = this.store.pipe(select(CommonSelectors.getEditMode));
  defaultFilters$ = this.store.pipe(select(CommonSelectors.getDefaultFilters));

  constructor(private store: Store<fromCommon.CommonPartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  setEditMode(editMode: boolean) {
    return this.dispatch(CommonActions.setEditMode({ editMode }));
  }

  setDefaultFilter(url: string, defaultFilter: Object) {
    return this.dispatch(
      CommonActions.setDefaultFilter({ url, defaultFilter })
    );
  }
}
